import React, { useState } from 'react';
import { BookOpen, ShieldCheck, QrCode, FileSpreadsheet, Lock } from 'lucide-react';
import { PrivacyPolicyModal } from './PrivacyPolicyModal.js';

export const Footer: React.FC = () => {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);

  return (
    <>
      <footer className="bg-white border-t border-slate-200/90 py-10 mt-16 text-slate-500 text-xs 2xl:text-sm">
        <div className="max-w-7xl 2xl:max-w-[1600px] 3xl:max-w-[1760px] mx-auto px-4 sm:px-6 lg:px-8 2xl:px-12 space-y-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2.5">
              <div className="w-8 h-8 2xl:w-9 2xl:h-9 rounded-xl bg-indigo-600 text-white flex items-center justify-center">
                <BookOpen className="w-4 h-4 2xl:w-5 2xl:h-5" />
              </div>
              <div>
                <span className="font-bold text-slate-900 text-sm 2xl:text-base">UIBN Identifier System</span>
                <span className="text-[11px] 2xl:text-xs text-slate-400 block">Sistem Identifikasi Buku Digital</span>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-6 text-xs 2xl:text-sm text-slate-600">
              <span className="flex items-center gap-1.5">
                <ShieldCheck className="w-3.5 h-3.5 text-indigo-600" />
                <span>Algoritma Checksum Modulo-10</span>
              </span>
              <span className="flex items-center gap-1.5">
                <QrCode className="w-3.5 h-3.5 text-indigo-600" />
                <span>Barcode 1D & QR 2D</span>
              </span>
              <span className="flex items-center gap-1.5">
                <FileSpreadsheet className="w-3.5 h-3.5 text-indigo-600" />
                <span>Ekspor CSV</span>
              </span>
            </div>
          </div>

          <div className="pt-6 border-t border-slate-100 flex flex-col sm:flex-row items-center justify-between gap-3 text-[11px] text-slate-400">
            <p>© {new Date().getFullYear()} UIBN Indonesia. Platform pengelolaan metadata buku dan generator kode unik berstandar.</p>
            <div className="flex items-center gap-4">
              <button
                type="button"
                onClick={() => setIsPrivacyOpen(true)}
                className="flex items-center gap-1 text-slate-500 hover:text-indigo-600 font-medium transition cursor-pointer min-h-[44px] px-2"
              >
                <Lock className="w-3.5 h-3.5 text-indigo-600" />
                <span>Kebijakan Privasi</span>
              </button>
              <span className="text-slate-300">•</span>
              <button
                type="button"
                onClick={() => setIsPrivacyOpen(true)}
                className="text-slate-500 hover:text-indigo-600 transition cursor-pointer min-h-[44px] px-2 flex items-center"
              >
                Syarat & Ketentuan
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <PrivacyPolicyModal
        isOpen={isPrivacyOpen}
        onClose={() => setIsPrivacyOpen(false)}
      />
    </>
  );
};

